import * as Scrivito from "scrivito"
import { DownloadObj } from "scrivito/Objs/Download/DownloadObjClass"

import { PimDataAttributes, PimDataObjClass } from "./PimDataObjClass"

function PimDataComponent({
  page
}: Scrivito.PageComponentProps<PimDataAttributes>) {
  const images = page.get("productImages")
  const documents = page.get("technicalDocumentation")
  return (
    <div className="pim-data">
      <div className="pim-data__product-name">
        <strong>Produktname: </strong>
        <Scrivito.ContentTag content={page} attribute="productType" />
      </div>
      <div className="pim-data__parent-product-name">
        <strong>Übergeordnetes Produkt: </strong>
        <Scrivito.ContentTag content={page} attribute="parentProductType" />
      </div>
      <div className="pim-data__parent-external-id">
        <strong>Übergeordnete externe ID: </strong>
        <Scrivito.ContentTag content={page} attribute="parentExternalId" />
      </div>
      <div className="pim-data__external-id">
        <strong>Externe ID: </strong>
        <Scrivito.ContentTag content={page} attribute="externalId" />
      </div>
      <div className="pim-data__technical-documentation">
        <strong>Technische Dokumentation: </strong>
        {documents && documents.length > 0 ? (
          <div>
            {documents.map(document => (
              <div key={document.id()}>
                <Scrivito.LinkTag content={document}>
                  {(document as DownloadObj).get("title")}
                </Scrivito.LinkTag>
              </div>
            ))}
          </div>
        ) : (
          <p>Keine technische Dokumentation vorhanden.</p>
        )}
      </div>
      <div className="pim-data__product-images">
        <strong>Produktbilder: </strong>
        {images && images.length > 0 ? (
          <div>
            {images.map((widget, index) => (
              <div key={widget.id()}>
                <Scrivito.ContentTag
                  content={page}
                  attribute="productImages"
                  index={index}
                />
              </div>
            ))}
          </div>
        ) : (
          <p>Keine Produktbilder vorhanden.</p>
        )}
      </div>
      <Scrivito.ContentTag content={page} attribute="body" />
    </div>
  )
}

Scrivito.provideComponent(PimDataObjClass, PimDataComponent)
